module.exports = " <router-outlet></router-outlet>\n\n <div style=\"clear: both\"></div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiscalia/component/forum/post/post.component.html
// module id = ./src/app/fiscalia/component/forum/post/post.component.html
// module chunks = main